import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Input, Icon, Checkbox, Divider} from 'antd';
import {SmallPopover, Button} from 'icsoc-antd-ex';
import IconFont from 'Components/common/iconFont';
import DetailDrawer from 'Components/detailDrawer';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import actions from 'Actions/taskManage/questionNaire';
import tDetailActions from 'Actions/taskManage/detail';
import {getByteLen, cutStr} from 'Utils';
import moment from 'moment';
import {result} from '../detail/config';
import login from '../../../reducers/login';

const CheckboxGroup = Checkbox.Group;

class TableList extends UnionTableList {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      columnsList: [],
      tableWidth: 1760,
      isDetailDrawerVisible: false, // 详情抽屉是否显示
      rowId: -1, // 当前点击的表格行id
      detailDrawerLoading: false, // 详情抽屉loading
      filterLists: {},
      answersList :[],//问答列表
    };
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    const {actions} = this.props;
    actions.setHeadSearchData({});
    actions.setPageStatus({
        pageNum: 1,
       pageSize: 10,
    });
    actions.setSearchData({
      startMillis: 0,
      endMillis: 0,
      taskId: 0,
    });
    this.getList('int')
  }

  // 导出
  download = () => {
    const {setReloadModalVisible} = this.props;
    setReloadModalVisible();
  };

  handleAction = (type, id) => {
    this[type](id);
  };

  // 显示通话详情抽屉
  showDetailDrawer = (id, type) => {
    const {tDetailActions} = this.props;

   
    tDetailActions.getDetailDrawerAnswerData(id).then(res=>{
      this.setState({
        // answersList:res.payload.data&&res.payload.data.contentRecords?res.payload.data.contentRecords:[]
        answersList:res.payload.data.contentRecords
      },()=>{
        if (type !== 'onRow') {
          this.setState({
            isDetailDrawerVisible: true,
          });
        }
    
        this.setState({
          rowId: id,
          detailDrawerLoading: true,
        });

      })
    })

    tDetailActions.getDetailDrawerData(id).finally(() => {
      this.setState({
        detailDrawerLoading: false,
      });
    });
  };

  // 关闭通话详情抽屉
  closeDetailDrawer = () => {
    this.setState({
      rowId: -1,
      isDetailDrawerVisible: false,
    });
  };

  // 查询，确定表头并获取数据
  getList = int => {
    const {tableHead} = this.props;
    const f = {};
    Object.keys(tableHead.contentRecords).map(item => {
      tableHead.contentRecords[item] = tableHead.contentRecords[item].map(
        item => {
          return {
            ...item,
            value: `${item.value}  (${item.total})`,
            label: `${item.label}  (${item.total})`,
          };
        },
      );
      const checkedList = tableHead.contentRecords[item].map(item => {
        return item.value;
      });
      f[item] = {
        checkedList,
        finalCheckedList: checkedList,
        indeterminate: false,
        checkAll: true,
        plainOptions: tableHead.contentRecords[item],
        options: tableHead.contentRecords[item],
        total: tableHead.total,
      };
      return item;
    });
    const tableX = 600 * tableHead.totalMax + 1760;
    this.setState(
      {
        filterLists: {...f},
      },
      () => {
        const {filterLists} = this.state;
        // 表头拼接
        // 表头固定部分
        const columns = [
          {
            title: '呼叫标识',
            dataIndex: 'id',
            key: 'id',
            width: 170,
            fixed: 'left',
            render: text => text || '--',
          },
          {
            title: '第三方标识',
            dataIndex: 'clientName',
            key: 'clientName',
            width: 120,
            render: text => text || '--',
          },
          {
            title: '主叫号码',
            dataIndex: 'caller',
            key: 'caller',
            width: 150,
            render: text => text || '--',
          },
          {
            title: '电话号码',
            dataIndex: 'phone',
            key: 'phone',
            width: 150,
            render: text => text || '--',
          },
          {
            title: '任务名称',
            dataIndex: 'taskName',
            key: 'taskName',
            width: 150,
            render: text => text || '--',
          },
          {
            title: '通话时长(秒)',
            dataIndex: 'lastTime',
            key: 'lastTime',
            width: 120,
            render: text => text || '--',
          },
          {
            title: '联系结果',
            dataIndex: 'result',
            key: 'result',
            width: 120,
            render: text => result[text] || '--',
          },
          {
            title: '提交时间',
            dataIndex: 'commitTime',
            key: 'commitTime',
            width: 200,
            render: text =>
              (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
          },
          {
            title: '呼出时间',
            dataIndex: 'callTime',
            key: 'callTime',
            width: 200,
            render: text =>
              (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
          },
          {
            title: '次数',
            dataIndex: 'callIndex',
            key: 'callIndex',
            width: 100,
            render: text => text || '--',
          },
          {
            title: '接收挂机消息时间',
            dataIndex: 'receiveTime',
            key: 'receiveTime',
            width: 200,
            render: text =>
              (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
          },
          {
            title: '通话结束时间',
            dataIndex: 'endTime',
            key: 'endTime',
            width: 200,
            render: text =>
              (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
          },
          {
            title: '操作',
            width: 60,
            dataIndex: 'operate',
            key: 'operate',
            fixed: 'right',
            render: (text, record) => {
              const {result, progress} = record;
              const resultNum = parseInt(result, 10);
              const progressNum = parseInt(progress, 10);
              // 联系结果：接听后挂断、转人工 可以查看详情
              const isSeeDetailDisable =
                resultNum === 2 || resultNum === 5 || progressNum === 1
                  ? ''
                  : ' is-disable';
              return (
                <div className="operate">
                  <SmallPopover
                    type="white"
                    content="查看详情"
                    className={`tooltip${isSeeDetailDisable}`}>
                    <IconFont
                      type="icon-robotdetails"
                      onClick={
                        isSeeDetailDisable === ' is-disable'
                          ? null
                          : () =>
                              this.handleAction('showDetailDrawer', record.id)
                      }
                    />
                  </SmallPopover>
                </div>
              );
            },
          },
        ];
        for (let i = 0; i < tableHead.totalMax; i++) {
          columns.splice(
            columns.length - 1,
            0,
            {
              title: `问题${i + 1}`,
              dataIndex: `question${i + 1}`,
              key: `question${i + 1}`,
              ...this.getColumnSearchProps(`question${i + 1}`, `问题${i + 1}`),
              width: 300,
              filterIcon: <IconFont type="icon-robotAPPshaixuan" />,
              render: text =>
                text ? (
                  <span title={text}>
                    {getByteLen(text) > 30 ? `${cutStr(text, 30)}...` : text}
                  </span>
                ) : (
                  '--'
                ),
            },
            {
              title: `问题${i + 1}答案`,
              dataIndex: `content${i + 1}`,
              key: `content${i + 1}`,
              ...this.getColumnSearchProps(
                `content${i + 1}`,
                `问题${i + 1}答案`,
              ),
              width: 300,
              filterIcon: <IconFont type="icon-robotAPPshaixuan" />,
              render: text =>
                text ? (
                  <span title={text}>
                    {getByteLen(text) > 30 ? `${cutStr(text, 30)}...` : text}
                  </span>
                ) : (
                  '--'
                ),
            },
          );
        }
        this.setState({columnsList: columns, tableWidth: tableX}, () => {
          this.changeList(int);
        });
      },
    );
    // this.setState({filterLists: {}}, () => {
    // });
  };

  // 获取数据
  changeList = (int, headSearh, page) => {
    const {actions, searchData, pageStatus, questionQueryReqs} = this.props;
    this.setState({loading: true});
    let params = {
      ...searchData,
      pageNum: page ? page.pageNum : pageStatus.pageNum,
      pageSize: page ? page.pageSize : pageStatus.pageSize,
      questionQueryReqs: headSearh || questionQueryReqs,
    };
    if (int === 'int') {
      params = {
        startMillis: 0,
        endMillis: 0,
        taskId: 0,
        pageNum: 1,
        pageSize: 10,
        questionQueryReqs: {},
      };
    }
    actions
      .getTableList(params)
      .then(() => {})
      .finally(() => {
        this.setState({loading: false});
      });
  };

  // 列搜索-start
  // 挂载搜索弹窗
  getColumnSearchProps = (dataIndex, name) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      const {filterLists} = this.state;
      return (
        <div style={{padding: 8, textAlign: 'left'}}>
          <Input
            ref={node => {
              this.searchInput = node;
            }}
            placeholder={`${name}`}
            value={selectedKeys[0]}
            suffix={
              <IconFont
                type="icon-robotsearch"
                onClick={() => this.handleSearch(selectedKeys, dataIndex)}
              />
            }
            onChange={e =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => this.handleSearch(selectedKeys, dataIndex)}
            style={{
              width: '100%',
              marginBottom: 8,
              display: 'block',
              marginLeft: -1,
            }}
          />
          <Checkbox
            style={{width: '100%', textAlign: 'left'}}
            indeterminate={filterLists[dataIndex]?.indeterminate}
            onChange={e => {
              this.onCheckAllChange(e, dataIndex);
            }}
            checked={filterLists[dataIndex]?.checkAll}>
            全选 ({filterLists[dataIndex]?.total})
          </Checkbox>
          <Divider style={{marginTop: 10, marginBottom: 10}} />
          {/* <Scrollbars> */}
          <div className="outFilterBoxs">
            <CheckboxGroup
              className="filterBoxs"
              style={{marginBottom: 12, textAlign: 'left', display: 'block'}}
              options={filterLists[dataIndex]?.plainOptions}
              value={filterLists[dataIndex]?.checkedList}
              onChange={list => this.onChange(list, dataIndex)}
            />
          </div>
          {/* </Scrollbars> */}
          <Button
            type="primary"
            onClick={() => this.handleOk(confirm)}
            size="small"
            style={{width: 90, marginRight: 8}}>
            确定
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters, dataIndex)}
            size="small"
            style={{width: 90}}>
            重置
          </Button>
        </div>
      );
    },

    filterIcon: filtered => (
      <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}} />
    ),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      } else {
        const {filterLists} = this.state;
        // this.handleSearch('', dataIndex);
        this.onChange(filterLists[dataIndex]?.finalCheckedList, dataIndex);
      }
    },
  });

  // 点击筛选项
  onChange = (list, dataIndex) => {
    const {filterLists} = this.state;
    this.setState({
      ...this.state,
      filterLists: {
        ...filterLists,
        [dataIndex]: {
          ...filterLists[dataIndex],
          checkedList: list,
          indeterminate:
            !!list.length &&
            list.length < filterLists[dataIndex].plainOptions.length,
          checkAll: list.length === filterLists[dataIndex].plainOptions.length,
        },
      },
    });
  };

  // 点击全选
  onCheckAllChange = (e, dataIndex) => {
    const {filterLists} = this.state;
    filterLists[dataIndex].checkedList = e.target.checked
      ? filterLists[dataIndex].plainOptions.map(item => {
          return item.value;
        })
      : [];
    filterLists[dataIndex].indeterminate = false;
    filterLists[dataIndex].checkAll = e.target.checked;
    this.setState({filterLists});
  };

  // 搜索
  handleSearch = (selectedKeys, dataIndex) => {
    const {filterLists} = this.state;
    filterLists[dataIndex].checkAll = false;
    filterLists[dataIndex].indeterminate = false;
    let total = 0;
    filterLists[dataIndex].plainOptions = filterLists[dataIndex].options.filter(
      item => {
        if (selectedKeys[0]) {
          if (item.value.indexOf(selectedKeys[0]) !== -1) {
            total += item.total;
          }
          return item.value.indexOf(selectedKeys[0]) !== -1;
        }
        total += item.total;
        return item;
      },
    );
    filterLists[dataIndex].checkedList = filterLists[
      dataIndex
    ].plainOptions.map(item => {
      return item.value;
    });
    filterLists[dataIndex].finalCheckedList = filterLists[
      dataIndex
    ].plainOptions.map(item => {
      return item.value;
    });
    filterLists[dataIndex].total = total;
    filterLists[dataIndex].checkAll = true;
    this.setState({filterLists});
  };

  // 确定
  handleOk = confirm => {
    const {filterLists} = this.state;
    const {actions, pageStatus} = this.props;
    const questionQueryReqs = {};
    Object.keys(filterLists).map(item => {
      questionQueryReqs[item] = [];
      filterLists[item].finalCheckedList = filterLists[item].checkedList;
      filterLists[item].finalCheckedList.map(val => {
        const idList = filterLists[item].plainOptions.filter(v => {
          return v.value === val;
        });
        questionQueryReqs[item].push(idList[0].ids);
        return val;
      });
      return item;
    });
    this.setState({filterLists});
    actions.setHeadSearchData(questionQueryReqs);
    actions.setPageStatus({pageNum: 1, pageSize: pageStatus.pageSize});
    confirm();
    this.changeList('', questionQueryReqs, {
      pageNum: 1,
      pageSize: pageStatus.pageSize,
    });
  };

  // 重置
  handleReset = (clearFilters, dataIndex) => {
    const {tableHead} = this.props;
    const {filterLists} = this.state;
    const checkedList = tableHead.contentRecords[dataIndex].map(item => {
      return item.value;
    });
    filterLists[dataIndex] = {
      checkedList,
      finalCheckedList: checkedList,
      indeterminate: false,
      checkAll: true,
      plainOptions: tableHead.contentRecords[dataIndex],
      options: tableHead.contentRecords[dataIndex],
      total: tableHead.total,
    };
    this.setState({filterLists});
    this.handleOk(clearFilters);
  };
  // 列搜索-end

  // 翻頁
  headTableChange = pagination => {
    const {current, pageSize} = pagination;
    const {actions, searchData, questionQueryReqs} = this.props;
    actions.setSearchData({
      ...searchData,
      questionQueryReqs,
    });
    actions.setPageStatus({pageNum: current, pageSize});
    actions.getTableList({
      ...searchData,
      questionQueryReqs,
      pageNum: current,
      pageSize,
    });
  };

  render() {
    const {
      tableListData: {data = [], total = 0},
      pageStatus: {pageNum, pageSize},
      detailDrawerData,login
    } = this.props;
    const {
      rowId,
      loading,
      columnsList,
      tableWidth,
      isDetailDrawerVisible,
      detailDrawerLoading,
      answersList 
    } = this.state;
    return (
      <div className="tableList">
        <div className="title">
          <span>回答结果</span>
          {
            login.permissionsList.includes('taskManageQuestionNaire.export') ?
            <Button
              type="primary"
              onClick={() => this.download()}
              style={{marginRight: 10}}>
              导出结果
            </Button>
          : null}
        </div>
        <React.Fragment>
          <div className="table">
            <CommonTable
              columns={columnsList}
              dataSource={[...data]}
              rowKey="id"
              loading={loading}
              extraHeight={55}
              width={1760}
              scroll={{x: tableWidth + 20}}
              onChange={this.headTableChange}
              pagination={{
                current: pageNum,
                total: total && parseInt(total, 10),
                pageSize,
                showTotal: () => `共 ${total} 条`,
              }}
              rowClassName={record => (rowId === record.id ? 'row-back' : '')}
              onRow={record => ({
                onClick: data => {
                  if (
                    data.target &&
                    data.target.tagName !== 'use' &&
                    data.target.tagName !== 'svg' &&
                    isDetailDrawerVisible
                  ) {
                    if (
                      parseInt(record.result, 10) === 2 ||
                      parseInt(record.result, 10) === 5
                    ) {
                      this.showDetailDrawer(record.id, 'onRow');
                    } else {
                      this.closeDetailDrawer();
                    }
                  }
                },
              })}
            />
            {isDetailDrawerVisible ? (
              <DetailDrawer
                pageType="quesNaire"
                id={rowId}
                loading={detailDrawerLoading}
                dataSource={detailDrawerData}
                answersList ={answersList }
                onClose={this.closeDetailDrawer}
              />
            ) : null}
          </div>
        </React.Fragment>
      </div>
    );
  }
}

const mapStateToProps = ({
  taskManageQuestionNaire,
  taskManageDetail,
  login,
}) => ({
  tableListData: taskManageQuestionNaire.tableListData,
  searchData: taskManageQuestionNaire.searchData,
  tableHead: taskManageQuestionNaire.tableHead,
  pageStatus: taskManageQuestionNaire.pageStatus,
  detailDrawerData: taskManageDetail.detailDrawerData,
  questionQueryReqs: taskManageQuestionNaire.questionQueryReqs,
  login,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  tDetailActions: bindActionCreators(tDetailActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {withRef: true},
)(TableList);
